export enum WizardItemType {
	DYNAMIC = 'dynamic',
	V_STACK = 'vstack',
	CAROUSEL = 'carousel',
	VIDEO = 'video',
	TEXT = 'text',
	IMAGE = 'image',
	SUBMIT_BUTTON = 'submitButton',
	APP_NEWS_BUTTON = 'appNewsButton',
	BUTTON = 'button',
	CONTAINER = 'container'
}